export const RETURN_GROUP_LINKS = {
  BASE: "/app/returns",
  PROGRESS: "/app/returns/in-progress",
  COMPLETED: "/app/returns/completed",
};
